import { Injectable } from '@angular/core';
import { NativeFaceTrackingData } from '@models/face-tracking-data';

import { FaceTracker } from './face-tracker';

@Injectable({ providedIn: 'root' })
export class NativeFaceTrackerService extends FaceTracker {
  faceDetector: FaceDetector;

  initialize(): Promise<this> {
    this.faceDetector = new FaceDetector({ maxDetectedFaces: 2, fastMode: false });
    return Promise.resolve(this);
  }

  protected async trackFaces() {
    const imageData = await this.stream.camera.snapData(this.stream);
    const faces = await this.faceDetector.detect(imageData);
    this.faceTrackingData.emit(new NativeFaceTrackingData(faces));
  }
}
